import React from 'react';
import colors from '../../utils/colors';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import './BannerMessage.scss';

export const BannerMessage = ({ children, displayBanner, closeBanner }) => {
  return displayBanner ? (
    <div className={`banner-container`}>
      <Svg
        className={'banner-icon'}
        data={'/assets/warning.svg'}
        fill={colors.white}
      />
      <div className={'banner-text'}>{children}</div>
      <Svg
        className={'banner-close-icon'}
        data={'/assets/close.svg'}
        fill={colors.white}
        onClickAction={closeBanner}
      />
    </div>
  ) : <></>;
};

BannerMessage.propTypes = {
  children: PropTypes.any,
  displayBanner: PropTypes.bool,
  closeBanner: PropTypes.func,
};
